import { useEffect, useState } from "react";

import Layout from "./Layout.jsx";
import Home from "./Home.jsx";
import Start from "./Start.jsx";
import Complaint from "./Complaint.jsx";
import Resources from "./Resources.jsx";
import Admin from "./Admin.jsx";
import Login from "./Login.jsx";
import NotFound from "./NotFound.jsx";

const routes = {
  "/": Home,
  "/start": Start,
  "/complaint": Complaint,
  "/resources": Resources,
  "/admin": Admin,
  "/login": Login,
};

function normalizePath(pathname) {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/, "");
}

function useRoute() {
  const [path, setPath] = useState(() =>
    normalizePath(window.location.pathname)
  );

  useEffect(() => {
    const handlePopState = () => {
      setPath(normalizePath(window.location.pathname));
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const navigate = (href) => {
    if (!href || typeof href !== "string") {
      return;
    }

    const destination = new URL(href, window.location.origin);

    if (destination.origin !== window.location.origin) {
      window.location.href = destination.href;
      return;
    }

    const nextPath = normalizePath(destination.pathname);

    window.history.pushState({}, "", destination.href);
    setPath(nextPath);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return {
    path,
    navigate,
  };
}

export default function App() {
  const { path, navigate } = useRoute();
  const Page = routes[path] ?? NotFound;

  return (
    <Layout path={path} navigate={navigate}>
      <Page path={path} navigate={navigate} />
    </Layout>
  );
}
